module.exports = __webpack_public_path__ + "static/media/fun8.3b542e79.png";